import { render, staticRenderFns } from "./RewardSVG.vue?vue&type=template&id=669ccff4"
import script from "./RewardSVG.vue?vue&type=script&lang=js"
export * from "./RewardSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports